<template>
  <div style="margin-top: 70px">
    <v-container class="mt-5">
      <!-- <div class="ma-auto" v-if="error">
        <v-layout text-center wrap>
          <app-alert @dismissed="onDismissed" :message="error.message"></app-alert>
        </v-layout>
      </div>-->
      <v-layout text-center wrap>
        <v-flex xs12>
          <!-- <v-card
            style="
              background-color: black;
              border-radius: 26px;
              border: 1px solid #a07800;
              max-width: 800px;
            "
            outlined
            tile
            rounded
            class="ma-auto"
          > -->
          <v-flex>
            <v-card
              class="ma-auto"
              outlined
              style="
                  border-radius: 26px;
                  max-width: 800px
                "
            >
              <v-card-title>
                <span class="font-weight-light">LOG</span>
                <span class="red--text">IN</span>
              </v-card-title>

              <v-form class="ma-2 pa-2" @submit.prevent="onLogin">
                <v-expand-transition>
                  <div>
                    <v-card
                      style="
                          border-radius: 26px;
                          max-width: 500px;
                        "
                      outlined
                      tile
                      rounded
                      class="ma-auto"
                    >
                      <!-- <v-card
                      style="border-radius: 26px; max-width: 700px"
                      outlined
                      tile
                      rounded
                      class="ma-auto"
                      color="grey darken-6"
                      light
                        >-->
                      <!-- EMAIL  -->
                      <v-text-field
                        label="EMAIL"
                        name="email"
                        validate-on-blur
                        required
                        id="email"
                        class="ma-2"
                        outlined
                        v-model="email"
                        autofocus
                        clearable
                        :rules="[rules.email]"
                        type="email"
                        shaped
                      ></v-text-field>
                      <!-- PASSWORD  -->
                      <v-text-field
                        label="PASSWORD"
                        name="password"
                        required
                        id="password"
                        class="ma-2"
                        outlined
                        v-model="password"
                        validate-on-blur
                        clearable
                        type="password"
                        :rules="[rules.length(6)]"
                        counter="6"
                      ></v-text-field>
                    </v-card>
                  </div>
                </v-expand-transition>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    rounded
                    type="submit"
                    class="mt-3"
                    outlined
                    color="primary"
                  >
                    LOGIN
                    <template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn text @click="sendResetEmail" class="mt-3"
                    >reset password</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
                <!-- <v-layout row>
                  <v-spacer></v-spacer>
                  <v-btn rounded text outlined class="mt-3" color="red"
                    >CANCEL</v-btn
                  >
                  <v-spacer></v-spacer>
                 
                  <v-btn
                    rounded
                    color="white"
                    dark
                    type="submit"
                    class="mt-3"
                    outlined
                  >
                    LOGIN
                    <template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template>
                  </v-btn>
                  <v-btn
                    rounded
                    color="white"
                    dark
                    @click="sendResetEmail"
                    class="mt-3"
                    outlined
                    >reset password</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-layout> -->
              </v-form>
            </v-card>
          </v-flex>
          <!-- </v-card> -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  data: () => ({
    //
    email: "",
    password: "",
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      length: len => v =>
        (v || "").length >= len || `Invalid character length, required ${len}`
      // password: v => (v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
      //   'Password must contain an upper case letter, a numeric character, and a special character',
    }
  }),
  computed: {
    user() {
      return this.$store.getters.user;
    }
    //  appMessage() {
    //   return this.$store.getters.appMessage;
    // },
    //   error() {
    //     return this.$store.getters.error;
    //   },
    //   loading() {
    //     return this.$store.getters.loading;
    //   }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        // this.$store.dispatch("loadMatters", value);
        console.log("user from login to /:", value);
        this.$router.replace("/");
      }
    }
  },
  methods: {
    onLogin() {
      this.$store.dispatch("signUserIn", {
        email: this.email,
        password: this.password
      });
      // this.$router.push("/");
    },
    // onDismissed() {
    //   console.log("dismissed alert");
    //   this.$store.dispatch("clearError");
    // }
    sendResetEmail() {
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          alert(`Reset Email Sent To: ${this.email}`);
        })
        .catch(e => {
          alert(`Error Code: ${e.code}, Error Message: ${e.message}`);
        });
    }
    //  clearAppMessage() {
    //   this.$store.dispatch("setAppMessage", null);
    // },
  }
};
</script>

<style scoped></style>
